import React from 'react';
import ContainerHeader from '../components/ContainerHeader';
import {
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  Filter,
  GridComponent,
  Group,
} from '@syncfusion/ej2-react-grids';
import { Inject, Page, Sort, Search, Toolbar } from '@syncfusion/ej2-react-grids';
import { Button } from '@material-ui/core';
import { Box, Grid, Tab, Tabs } from '@mui/material';
import ConfirmationDialog from '../components/ConfirmDialogs/ConfirmationDialog';
import EditGenTaskFormDialog from './components/EditGenTaskFormDialogCtn';
import useGenTaskController from './CustomHooks/useGenTaskHook';
import { useAllUsers } from 'context/AllUserDataContext';
import { useMemo } from 'react';
import { data } from 'jquery';
import { Add } from '@mui/icons-material';
import AddGenTaskFormDialog from './components/AddGenTaskFormDialog';
import moment from 'moment';
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
class DebugBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught error:', error, info);
  }
  render() {
    if (this.state.hasError) return <div>Error in grid rendering</div>;
    return this.props.children;
  }
}

const GenTaskPage = props => {
  const pageSettings = useMemo(
    () => ({
      pageSize: 30,
      pageSizes: [5, 10, 20, 30, 40],
    }),
    [],
  );
  const filterSettings = {
    type: 'Excel',
  };
  const {
    confirmationDialogProps,
    openConfirmationDialog,
    setOpenConfirmationDialog,
    genTaskData,
    handleOpeneditDialogClick,
    openEditDialog,
    handleCloseEditDialogClick,
    selectedGenTask,
    handleSuccessfulSubmit,
    vehicalList,
    trailerList,
    checkListOption,
    typeOfRepairoption,
    // ── ADD ──
    openAddDialog,
    setOpenAddDialog,
    handleSuccessfulAdd,
  } = useGenTaskController();

  const contextMenuClick = args => {};
  const toolbarOptions = [{ text: 'Search', tooltipText: 'Search', prefixIcon: 'e-search', id: 'search' }];

  const editOptions = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Dialog' };
  const handleActionBegin = args => {
    if (args.requestType === 'beginEdit' || args.requestType === 'save') {
    }
  };
  const dateTemplate = (col, data) => {
    return moment(data[col.field]).format('YYYY-MM-DD HH:mm');
  };
  function editLinkTemplate(props) {
    return (
      <Button
        key={`${props.id}_site`}
        style={{ color: 'blue', fontWeight: 'bold', width: '100%' }}
        onClick={() => handleOpeneditDialogClick(props)}>
        {props.id}
      </Button>
    );
  }
  return (
    <div className="app-wrapper siteWrapper">
      <Box sx={2}>
        <Grid container alignItems="center" justifyContent="space-between" gap={2}>
          <Grid item xs>
            <ContainerHeader match={props.match} title="General Tasks" />
          </Grid>
          <Grid item>
            <Button variant="contained" color="primary" onClick={() => setOpenAddDialog(true)} startIcon={<Add />}>
              Add New Task
            </Button>
          </Grid>
        </Grid>
      </Box>
      <div style={{ height: 'calc(100vh - 140px)', width: '100%', paddingTop: '0.5rem' }}>
        <DebugBoundary>
          <GridComponent
            dataSource={genTaskData}
            filterSettings={filterSettings}
            allowPaging={true}
            pageSettings={pageSettings}
            allowSorting={true}
            allowTextWrap={true}
            allowResizing={true}
            allowMultiSorting={true}
            allowReordering={true}
            allowFiltering={true}
            style={{
              minHeight: 'auto !important',
            }}
            actionBegin={handleActionBegin}
            height="100%"
            toolbar={toolbarOptions}>
            <ColumnsDirective>
              <ColumnDirective
                field="id"
                headerText="Edit Link"
                width="80"
                textAlign="Left"
                isPrimaryKey={true}
                template={editLinkTemplate}
              />
              <ColumnDirective field="employeeName" headerText="Name" width="100" />
              <ColumnDirective field="task" headerText="Select Task" width="100" />
              <ColumnDirective field="dateAndTime" headerText="Date & Time" width="100" formatter={dateTemplate} />
              <ColumnDirective field="forestSPNumber" headerText="Forest SP Number" width="100" />
              <ColumnDirective field="vehicle" headerText="Machine" width="100" />

              <ColumnDirective field="mileageReadingKM" headerText="Mileage Reading KM" width="80" textAlign="Right" />
            </ColumnsDirective>
            <Inject services={[Page, Sort, Filter, Group, Search, Toolbar]} />
          </GridComponent>
        </DebugBoundary>
      </div>

      <ConfirmationDialog
        open={openConfirmationDialog}
        setOpen={setOpenConfirmationDialog}
        confirmationFun={confirmationDialogProps.confirmFnc}
        declineFunction={confirmationDialogProps.cancleFnc}
        confirmationText={confirmationDialogProps.confirmText}
      />

      <AddGenTaskFormDialog
        open={openAddDialog}
        setOpen={setOpenAddDialog}
        handleSuccessfulSubmit={handleSuccessfulAdd}
        checkListOpt={checkListOption}
        vehicalList={vehicalList}
        trailerList={trailerList}
        typeOfRepairoption={typeOfRepairoption}
      />

      <EditGenTaskFormDialog
        handleSuccessfulSubmit={handleSuccessfulSubmit}
        open={openEditDialog}
        setOpen={handleCloseEditDialogClick}
        selectedGenTask={selectedGenTask}
        checkListOpt={checkListOption}
        vehicalList={vehicalList}
        trailerList={trailerList}
        typeOfRepairoption={typeOfRepairoption}
      />
    </div>
  );
};

export default GenTaskPage;
